<template>
     
  <v-container grid-list-md>

    <div>
      <span class="display-1">Notifications</span>
    </div>

  
    <div class="pt-4">
      <v-card class="pa-8 mb-2">
        Sanitary ID will expire 2 MAY
      </v-card>
      <v-card class="pa-8 mb-2">
        End of 2020, we need to add the returned balms of PVCBD
      </v-card>
      <v-card class="pa-8 mb-2">
        Allow product returns
      </v-card>
      <v-card class="pa-8 mb-2">
        Preserve history (for example when in customers section. on page two and you click on a customer and then go back, preserve that page with keep-alive and remember to use activated lifecycle hooks
      </v-card>
    </div>


    <v-card>
      <reminders></reminders>
    </v-card>
  
  </v-container>
</template>

<script>
import Reminders from '@/components/ui/reminders/main'
export default {
  components: {
    Reminders
  }
}
</script>
